import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { PlanTemplateType, useStartPlanPayment } from '../../../plan-payment';
import { PLAN_PRICES_PER_CCU } from '../../../shared';
import { usePricingLocale } from '../hooks';
import { BasicPlanCard, EnterprisePlanCard, FreePlanCard, ProPlanCard } from './NormalPlans';
import S from './PricingPlans.module.scss';
interface PayTabContentProps {
  priceType: 'monthly' | 'yearly';
  subscriptionPeriod: '30' | '365';
}
export const PayTabsContent = ({
  priceType,
  subscriptionPeriod
}: PayTabContentProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    push
  } = useRouter();
  const locale = usePricingLocale();
  const prices = PLAN_PRICES_PER_CCU[locale][priceType];
  const coreQuoteTerm = subscriptionPeriod === '365' ? '12' : '1';
  const {
    handleStartPlanPayment
  } = useStartPlanPayment();
  return <div className={S.plan_list} role="list" data-sentry-component="PayTabsContent" data-sentry-source-file="PayTabsContent.tsx">
      <div className={S.plan_item} role="listitem">
        <FreePlanCard onClickCardButton={() => {
        push('/home/spaces');
      }} data-sentry-element="FreePlanCard" data-sentry-source-file="PayTabsContent.tsx" />
      </div>

      <div className={S.plan_item} role="listitem">
        <BasicPlanCard pricePerUser={prices.basic} coreQuoteTerm={coreQuoteTerm} onClickCardButton={() => {
        handleStartPlanPayment({
          planType: 'basic',
          planTemplateType: PlanTemplateType.PRODUCT_SUBSCRIPTION,
          subscriptionPeriod
        });
      }} data-sentry-element="BasicPlanCard" data-sentry-source-file="PayTabsContent.tsx" />
      </div>

      <div className={S.plan_item} role="listitem">
        <ProPlanCard pricePerUser={prices.pro} coreQuoteTerm={coreQuoteTerm} onClickCardButton={() => {
        handleStartPlanPayment({
          planType: 'pro',
          planTemplateType: PlanTemplateType.PRODUCT_SUBSCRIPTION,
          subscriptionPeriod
        });
      }} data-sentry-element="ProPlanCard" data-sentry-source-file="PayTabsContent.tsx" />
      </div>

      <div className={S.plan_item} role="listitem">
        <EnterprisePlanCard onClickCardButton={() => {
        window.open(t('subscription:subscription.salesmap.link'), '_blank');
      }} data-sentry-element="EnterprisePlanCard" data-sentry-source-file="PayTabsContent.tsx" />
      </div>
    </div>;
};